import { createRouter, createWebHistory } from 'vue-router'

import Dashboard from '@/views/Dashboard.vue';
import Auth from '@/views/Auth.vue';
import Conversation from "@/views/Conversation.vue";
import SharedConversation from "@/views/SharedConversation.vue";
import Kyle from "@/views/Kyle.vue";

import { useAuthStore } from '@/stores/auth';
import UpgradeBenefits from "@/views/UpgradeBenefits.vue";

const routes = [
  { path: '/', name: 'Login', component: Auth },
  { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { path: '/conversation', redirect: '/' },
  { path: '/conversation/:uuid', component: Conversation, props: true, name: 'Conversation', meta: { requiresAuth: true } },
  { path: '/shared/:uuid', component: SharedConversation, props: true, name: 'SharedConversation', meta: { requiresAuth: false } },

  { path: '/kyle', component: Kyle, props: true, meta: { requiresAuth: true } },

  { path: '/premium', component: UpgradeBenefits, name: 'UpgradeBenefits', props: true, meta: { requiresAuth: true } },

  { path: '/premium/thank-you', component: () => import('@/views/PremiumThankYou.vue'), name: 'PremiumThankYou', props: true, meta: { requiresAuth: true } },
  { path: '/premium/cancel', component: () => import('@/views/PremiumCancel.vue'), name: 'PremiumCancel', props: true, meta: { requiresAuth: true } },


  { path: '/:pathMatch(.*)*', redirect: '/' }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  if (authStore.loading) {
    await new Promise(resolve => {
      const stop = authStore.$subscribe(() => {
        stop(); resolve();
      });
    });
  }

  let isAuthenticated = authStore.user !== null;

  if (
      // make sure the user is authenticated
      !isAuthenticated &&
      // ❗️ Avoid an infinite redirect
      to.name !== 'Login'
  ) {
    // redirect the user to the login page
    return { name: 'Login' }
  }

  if (to.meta.requiresAuth && !authStore.user) {
    next('/');
  } else {
    next();
  }
});

export default router
